import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { map, filter } from 'ramda';
import { connect } from 'react-redux';
import { useSwipeable } from 'react-swipeable';
import { IReferenceCandidateForm } from '../../../../common/models/reference/IReferenceCandidateForm';
import RegularButton from '../../../../components/RegularButton';
import ReferenceCard from '../ReferenceCard';
import { IBindingAction, IBindingCallback1 } from '../../../../common/models/callback';
import { IAppState } from '../../../../common/models/store/IAppState';
import { ReactComponent as Plus } from '../../../../assets/icons/plus.svg';
import { ReactComponent as ArrowRight } from '../../../../assets/icons/arrow-right.svg';
import styles from './styles.module.scss';

interface IFinalizePagePage {
  onAddMoreReferences: IBindingAction;
  onPreviewEmail: IBindingCallback1<IReferenceCandidateForm[]>;
  updatedReferencesIds: string[];
  references: IReferenceCandidateForm[];
}

const FinalizePage: FunctionComponent<IFinalizePagePage> = ({
  references,
  updatedReferencesIds,
  onAddMoreReferences,
  onPreviewEmail
}) => {
  const newRefs = filter(r => updatedReferencesIds.includes(r.id as string) || r.id?.length !== 36, references);

  const swipeHandler = useSwipeable({
    onSwipedLeft: () => {
      if (references.length) onPreviewEmail(newRefs);
    },
    trackMouse: false
  });

  return references && (
  <div {...swipeHandler} className="cf-container justify-content-start cf-container-with-bttns">
    <div className="cf-title mb-2">
      <FormattedMessage id="candidateForm.finalize.title" defaultMessage="Confirm / edit added references" />
    </div>
    <p className="cf-subtitle mb-4">
      <FormattedMessage
        id="candidateForm.finalize.subtitle"
        defaultMessage={`
          Check if all the contact information you provided is correct.
          We will email (or SMS text) these references a link to a short survey. 
        `}
      />
    </p>
    <div className={styles.cards}>
      {map((ref: IReferenceCandidateForm) => (
        <ReferenceCard
          key={ref.id}
          reference={ref}
        />
      ), newRefs)}
    </div>
    <div className={`cf-buttons ${styles.buttons}`}>
      <RegularButton
        size="lg"
        variant="secondary"
        textIntlId="candidateForm.addReference"
        defaultMessage="Add reference"
        icon={<Plus />}
        iconPosition="right"
        onClick={onAddMoreReferences}
      />
      <RegularButton
        disabled={!references.length}
        size="lg"
        textIntlId="candidateForm.next"
        defaultMessage="Next"
        icon={<ArrowRight />}
        iconPosition="right"
        onClick={() => onPreviewEmail(newRefs)}
      />
    </div>
  </div>
  );
};

const mapStateToProps = ({
  referenceRequest: { references, updatedReferencesIds },
  workspace: { name: companyName }
}: IAppState) => ({ references, companyName, updatedReferencesIds });

export default connect(mapStateToProps)(FinalizePage);
